export default __webpack_public_path__ + "static/logo-8e214f87bae377617e61b130d28b82f7.svg";